import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomerDue, riskColors } from '../accountingTypes';
import styles from './CustomersDueTable.module.css';

interface CustomersDueTableProps {
  items: CustomerDue[];
}

export const CustomersDueTable: React.FC<CustomersDueTableProps> = ({ items }) => {
  const navigate = useNavigate();
  return (
    <div className={styles.section}>
      <h3 className={styles.title}>Customer's due</h3>
      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>CUSTOMER</th>
              <th>AREA</th>
              <th className={styles.right}>OUTSTANDING</th>
              <th>OVERDUE</th>
              <th className={styles.right}>0-30 DAYS</th>
              <th className={styles.right}>31-60 DAYS</th>
              <th className={styles.right}>61-90 DAYS</th>
              <th className={styles.right}>90+ DAYS</th>
              <th>CREDIT LIMIT</th>
              <th>LAST PAYMENT</th>
              <th>REP</th>
              <th>RISK</th>
              <th>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, idx) => {
              const rc = riskColors[item.risk];
              return (
                <tr key={idx}>
                  <td className={styles.customerName}>{item.customer}</td>
                  <td className={styles.area}>{item.area}</td>
                  <td className={`${styles.right} ${styles.outstanding}`}>{item.outstanding}</td>
                  <td className={styles.overdue}>{item.overdueDays}</td>
                  <td className={`${styles.right} ${styles.agingBucket}`}>{item.aging0_30}</td>
                  <td className={`${styles.right} ${styles.agingBucket}`}>{item.aging31_60}</td>
                  <td className={`${styles.right} ${styles.agingBucket}`}>{item.aging61_90}</td>
                  <td className={`${styles.right} ${styles.agingBucketOverdue}`}>{item.aging90Plus}</td>
                  <td>
                    <div className={styles.creditCell}>
                      <span>{item.creditLimit}</span>
                      <div className={styles.creditBar}>
                        <div
                          className={styles.creditFill}
                          style={{
                            width: `${item.creditUsedPercent}%`,
                            background: item.creditUsedPercent > 80 ? '#DC2626' : item.creditUsedPercent > 50 ? '#D97706' : '#16A34A',
                          }}
                        />
                      </div>
                    </div>
                  </td>
                  <td>{item.lastPayment}</td>
                  <td>{item.rep}</td>
                  <td>
                    <span
                      className={styles.riskBadge}
                      style={{ background: rc.bg, color: rc.color }}
                    >
                      {item.risk}
                    </span>
                  </td>
                  <td>
                    <div className={styles.actions}>
                      <button
                        type="button"
                        className={styles.ledgerBtn}
                        onClick={() => navigate('/invoices')}
                      >
                        Ledger
                      </button>
                      <button
                        type="button"
                        className={styles.payBtn}
                        onClick={() => navigate('/payments')}
                      >
                        Pay
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
